// Centralized API base resolution for the React app.
// Default: same origin as the page (served behind a reverse proxy in prod,
// behind CRA's setupProxy.js in dev). Overrides stay supported so a local UI
// can point at a remote API when needed:
//   REACT_APP_API_BASE / REACT_APP_AUTH_API_BASE  (build-time)
//   window.__API_BASE__ / window.__AUTH_API_BASE__ (runtime injection)
function originOrEmpty() {
  return typeof window !== "undefined" && window.location
    ? window.location.origin
    : "";
}

export function getApiBase() {
  const env = typeof process !== "undefined" ? process.env : {};
  const win = typeof window !== "undefined" ? window : {};
  const base =
    env?.REACT_APP_API_BASE || win?.__API_BASE__ || originOrEmpty();
  return String(base).replace(/\/$/, "");
}

export function getAuthApiBase() {
  const env = typeof process !== "undefined" ? process.env : {};
  const win = typeof window !== "undefined" ? window : {};
  // Auth lives at /auth on the same origin by default (nginx/IIS strips the
  // prefix; CRA dev proxy does the same path rewrite).
  const authBase =
    env?.REACT_APP_AUTH_API_BASE ||
    win?.__AUTH_API_BASE__ ||
    `${originOrEmpty()}/auth`;
  return String(authBase).replace(/\/$/, "");
}

export function apiEndpoint(path) {
  return `${getApiBase()}${path.startsWith("/") ? path : `/${path}`}`;
}

export function authApiEndpoint(path) {
  return `${getAuthApiBase()}${path.startsWith("/") ? path : `/${path}`}`;
}

export function readUseOpenAIFlag() {
  try {
    const raw =
      (typeof process !== "undefined" && process.env.REACT_APP_USE_OPENAI) ||
      (typeof window !== "undefined" && window.__USE_OPENAI__) ||
      (typeof localStorage !== "undefined"
        ? localStorage.getItem("use_openai")
        : null);
    if (raw === true) return true;
    if (raw === false) return false;
    const s = (raw || "").toString().trim().toLowerCase();
    if (!s) return false;
    return s === "1" || s === "true" || s === "yes" || s === "on";
  } catch {
    return false;
  }
}
